import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import load from "../../../assets/Images/loader.gif";

const optionAccessPointCount = [
    { label: "1", value: "1" },
];

const optionTypeOption = [
    { label: "Quarterly Advance", value: "B" },
    { label: "Half-Yearly Advance", value: "A" },
    { label: "Yearly Advance", value: "C" },
]

const optionWiredLanDevices = [
    { label: "Biometrics", value: "Biometrics" },
    { label: "Printers", value: "Printers" },
    { label: "CCTV", value: "CCTV" },
    { label: "IoT Devices", value: "IoTDevices" },
    { label: "Desktop PCs", value: "DesktopPCs" },
    { label: "Laptops", value: "Laptops" },
    { label: "DVR/NVR", value: "DvrNvr" },
    { label: "Smart TVs", value: "SmartTVs" },
    { label: "Other", value: "OtherWiredLanDevice" },
];

const SelectProductSOHO = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };


    const [loading, setLoading] = useState(false);
    const [billingFrequency, setBillingFrequency] = useState("");
    const [planName, setPlanName] = useState("");
    const [optionPlanName, setOptionPlanName] = useState([]);
    const [proposalCounter, setProposalCounter] = useState("");
    const [oppStatus, setOppStatus] = useState("");
    const [accessPointCount, setAccessPointCount] = useState(optionAccessPointCount[0]);
    const [totalCarpetArea, setTotalCarpetArea] = useState("");
    const [totalEmpCount, setTotalEmpCount] = useState("");
    const [otcPriceB, setOtcPriceB] = useState("");
    const [basePriceDisA, setBasePriceDisA] = useState("");
    const [basePriceDis, setBasePriceDis] = useState("");
    const [discountedBasePriceA, setDiscountedBasePriceA] = useState("");
    const [discountedBasePrice, setDiscountedBasePrice] = useState("");
    const [planDataShowAB, setPlanDataShowAB] = useState([]);
    const [planDataAB, setPlanDataAB] = useState([]);

    const [wiredLanDevices, setWiredLanDevices] = useState([]);
    const [noOfWiredLan, setNoOfWiredLan] = useState("");
    const [lanPortAddonCharges, setLanPortAddonCharges] = useState("");
    const [lanPortAddonDiscount, setLanPortAddonDiscount] = useState("");
    const [extendedLanCharges, setExtendedLanCharges] = useState("");
    const [nameOfOtherWLD, setNameOfOtherWLD] = useState("");

    const handleSelectBilling = (selected) => {
        setBillingFrequency(selected);
        setPlanName("");
        setPlanDataAB("");
        setPlanDataShowAB("");
        setOtcPriceB("");
        setNoOfWiredLan("");
        setLanPortAddonCharges("");
        setLanPortAddonDiscount("");
        setExtendedLanCharges("");
    }

    const handleTotalEmpCount = (e) => {
        setTotalEmpCount(e.target.value);
    };
    const handleTotalCarpetArea = (e) => {
        setTotalCarpetArea(e.target.value);
    };

    const handleSelectAccessPointCount = (select) => {
        setAccessPointCount(select);
    }

    // useEffect(() => {
    //     if (!planName) {
    //         setNoOfWiredLan("");
    //         setWiredLanDevices("");
    //         setLanPortAddonDiscount("");
    //     }
    // },[])

    const handleSelectPlanName = async (selectedOption) => {
        if (!billingFrequency.value) {
            toast.warning("please Select Billing Frequency", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            // const apiUrl = "https://ffamwapiuat.spectra.co/index.php";
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "getRecommendedPlanSOHO",
                "plan_name": selectedOption?.value,
            }
            const Response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });

            const data = await Response.json();
            if (data.Status == "Success") {
                setPlanName(selectedOption);
                console.log("planName", planName);
                
                if (!planName) {
                    setNoOfWiredLan("");
                    setWiredLanDevices([]);
                    setLanPortAddonDiscount("");
                }
            }
        } catch (error) {
            console.error("Error fetching Plans:", error);
        } finally {
            setLoading(false);
        }

    };


    const handleChangeLanPortAddonDiscount = (e) => {
        let value = Number(e.target.value);
        let lanDiscountLimit;
        if (billingFrequency.value == "A") {
             lanDiscountLimit = lanPortAddonCharges * 0.5;
        }else{
            lanDiscountLimit = lanPortAddonCharges;
        }
        if (value > lanDiscountLimit) {
            alert(`Discount cannot exceed ₹${lanDiscountLimit}`);
            setLanPortAddonDiscount("");
            return;
        }

        setLanPortAddonDiscount(value);
        const extendedLanChargesvalue = lanPortAddonCharges - value;
        console.log("extendedLanCharges", extendedLanChargesvalue);
        setExtendedLanCharges(extendedLanChargesvalue);
    };

    const handleChangeLanPortAddonCharges = (e) => {
        setLanPortAddonCharges(e.target.value);
    };

    const handleChangeNameOfOtherWLD = (e) => {
        setNameOfOtherWLD(e.target.value);
    };

    const handleChangeNoOfWiredLan = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        // Validation: prevent values greater than 8
        if (value && parseInt(value, 10) > 7) {
            toast.warning("Number of Wired LAN Ports cannot exceed 8", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return; // Don't update state if value is greater than 8
        }
        if (value && parseInt(value, 10) < 1) {
            setWiredLanDevices([]);
            setLanPortAddonCharges("");
            setNameOfOtherWLD("")
        }
        setNoOfWiredLan(value);

        if (value) {
            const ports = parseInt(value, 10);

            let addon = 0;
            if (ports > 0 && ports <= 8 && (billingFrequency.value == "A" || billingFrequency.value == "B")) {
                addon = 1000;
            }else if (ports > 0 && ports <= 8 && billingFrequency.value == "C"){
                 addon = 500;
            }
            //  else if (ports > 8) {
            //     addon = 1500 + (ports - 8) * 1500;
            // }

            setLanPortAddonCharges(addon.toString());
        } else {
            setLanPortAddonCharges(""); // reset if empty
        }
    };



    // const handleSelectWiredLanDevices = (selectedOptions) => {
    //     setWiredLanDevices(selectedOptions || []); // always array
    // };

    const handleSelectWiredLanDevices = (selected) => {
        if (selected && selected.length > Number(noOfWiredLan)) {
            toast.warning(
                "The number of Wired LAN Device options selected should not exceed the number of Wired LAN ports entered.",
                {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                }
            );
            return;
        }
        setWiredLanDevices(selected);

        const hasOtherDevice = selected?.some(
            (item) => item.value === "OtherWiredLanDevice"
        );

        if (!hasOtherDevice) {
            setNameOfOtherWLD("");
        }
    };

    const buildLanDevicesPayload = () => {
        const payload = {};
        optionWiredLanDevices?.forEach((device) => {
            payload[device.value] = wiredLanDevices?.some(
                (selected) => selected?.value === device.value
            )
                ? "1"
                : "0";
        });
        return payload;
    };

    const [userPriceData, setUserPriceData] = useState({
        basePriceReasonA: "",
        basePriceReasonB: ""
    });

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setUserPriceData({ ...userPriceData, [e.target.name]: e.target.value });
    };



    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const navigate = useNavigate();


    useEffect(() => {
        const fetchData = async () => {
            try {
                const url = process.env.REACT_APP_API_URL;
                const RequestBody = {
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    Action: "getOfficePlanNameList",
                    apCount: accessPointCount ? accessPointCount?.value : "",
                };

                const Response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(RequestBody),
                });

                const data = await Response.json();
                console.log("data", data.Response?.[0]);

                if (data.Response && Array.isArray(data.Response)) {
                    const options = data.Response.map((option) => ({
                        value: option.plan_tier,
                        label: option.plan_description,
                    }));

                    setOptionPlanName(options);
                } else {
                    setOptionPlanName([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [accessPointCount]);


    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getPlanOfficeByAB",
                    "plan_tier": planName?.value ? planName?.value : "",
                    "planType": billingFrequency?.value ? billingFrequency?.value : "",
                    "ap": accessPointCount ? accessPointCount?.value : accessPointCount?.value,
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                if (result.Status == "Success") {

                    setPlanDataAB(result.Response[0]);
                    setPlanDataShowAB(result.Response);

                    console.log("result.Response[0]", result.Response[0].otc);
                    // setMaxOtcPriceB(result?.Response[0].max_discount_OTC);
                    setOtcPriceB(result?.Response[0].otc);
                    setBasePriceDisA("");
                    setUserPriceData({
                        basePriceReasonA: ""
                    })

                }
            } catch (error) {
                console.error("Error fetching Plans:", error);
            }

        };

        fetchPlans();
    }, [accessPointCount, planName]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                if (responsedata?.Status === "Success" && responseData) {

                    setProposalCounter(responsedata.Response.Data[0]?.PgInfo.ProposalCounter);
                    setOppStatus(responsedata.Response?.Data[0]?.Status);

                    setTotalCarpetArea(responsedata.Response?.Data[0]?.PgInfo?.OfficeArea);
                    setTotalEmpCount(responsedata.Response?.Data[0]?.PgInfo?.EmployeeCount);
                    setNameOfOtherWLD(responsedata.Response?.Data[0]?.PgInfo?.NameOfOtherWLD);
                    setLanPortAddonCharges(responsedata.Response?.Data[0]?.PgInfo?.LANPortAddonCharges);
                    // setNoOfWiredLan(responsedata.Response?.Data[0]?.PgInfo?.NumberofWiredLANPorts);
                    // console.log("responsedata.Response?.Data[0]?.PgInfo?.LanportaddDiscountPrice", responsedata.Response?.Data[0]?.PgInfo?.LanportaddDiscountPrice);

                    // setLanPortAddonDiscount(responsedata.Response?.Data[0]?.PgInfo?.LanportaddDiscountPrice)
                    // // setUserPriceData({basePriceReasonB:""})
                    // const pgInfo = responseData.PgInfo;

                    // const selectedDevices = optionWiredLanDevices?.filter((opt) => {
                    //     const key = opt.value; // must match API field name
                    //     return pgInfo[key] === "1";
                    // });
                    // setWiredLanDevices(selectedDevices);


                }

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [OppId]);

    const handleBasePriceDis = (e) => {
        let value = Number(e.target.value);
        const discountLimit = otcPriceB;
        // Validation
        if (value > discountLimit) {
            alert(`Discount cannot exceed ₹${discountLimit}`);
            setBasePriceDis(""); // Clear input if invalid
            return;
        }

        setBasePriceDis(value);
        const discountedOtc = otcPriceB - value;
        // console.log("discountedOtcB", discountedOtcB);

        setDiscountedBasePrice(discountedOtc);
    };


    const handleCreateProposal = async () => {
        const hasOnlyOther =
            wiredLanDevices?.length > 0 &&
            wiredLanDevices?.every((d) => d?.value === "OtherWiredLanDevice");
        if (!planName) {
            toast.warning("Plan must be selected", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (Number(noOfWiredLan) > 0 && wiredLanDevices?.length === 0) {
            toast.warning("Please Select at least One Wired LAN Device", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return;
        }
        if (hasOnlyOther) {
            if (!nameOfOtherWLD || nameOfOtherWLD == "0") {
                toast.warning("Please Enter Specific Device Name", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }
        if (lanPortAddonDiscount > 0) {
            if (!userPriceData?.basePriceReasonB) {
                toast.warning("Please Enter Discount Reason", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return;
            }
        }
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateOptyProductSOHO",
                "UserName": sessionStorage.getItem('userName'),
                "Password": sessionStorage.getItem('password'),
                "Baseplan": {
                    "OpportunityID": OppId || "",
                    "APCount": accessPointCount ? accessPointCount?.value : accessPointCount?.value,
                    "ProductID": planDataShowAB?.[0]?.crm_plan_id,
                    "RC": planDataShowAB?.[0]?.monthly_price,
                    "OTC": discountedBasePrice ? discountedBasePrice : planDataShowAB?.[0]?.otc,
                    "OTCPriceDiscount": basePriceDis ? basePriceDis : "",
                    "DiscountReason": userPriceData?.basePriceReasonB ? userPriceData?.basePriceReasonB : "",
                    ...buildLanDevicesPayload(),
                    "NameOfOtherWLD": nameOfOtherWLD,
                    "NumberofWiredLANPorts": noOfWiredLan ? noOfWiredLan : "",
                    "LANPortAddonCharges": lanPortAddonCharges ? lanPortAddonCharges : "",
                    "LANPortAddDiscountPrice": lanPortAddonDiscount ? lanPortAddonDiscount : "",
                    "LANPortAddonExtendedPrice": extendedLanCharges ? extendedLanCharges : ""
                }
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate(`/BusinessProWifiOpp?OppId=${OppId}`);

                setTimeout(async () => {
                    if (basePriceDis > 0 || lanPortAddonDiscount > 0) {
                        try {
                            const apiUrl = process.env.REACT_APP_API_URL;
                            const requestData = {
                                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                "Action": "createApprovals",
                                "userName": sessionStorage.getItem("userName"),
                                "password": sessionStorage.getItem("password"),
                                "OppId": OppId,
                                "Reason": userPriceData?.basePriceReasonB
                            }
                            const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(requestData),
                            });

                            const result = await response.json();
                            // console.log("Plan Response:", result.Response);
                            if (result?.Response?.StatusCode == 200) {
                                toast.success(result?.Response?.Message, {
                                    position: toast.POSITION.BOTTOM_CENTER,
                                    autoClose: 1500,
                                });
                            }

                        } catch (error) {
                            console.error("Error fetching Plans:", error.message);
                        }
                    }
                }, 5000);

            } else {
                toast.warning(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        } catch (error) {
            console.error("Error fetching discounts:", error.message);
        } finally {
            setLoading(false);
        }
    }


    const redirectOpportunity = () => {
        navigate(`/BusinessProWifiOpp?OppId=${OppId}`);
    };



    return (
        <>
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectOpportunity}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-2">Plan Selector</span>
                </div>
            </div>

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <div className="container shadow mb-3 bg-body rounded form-container" id="form3">
                    <fieldset className="Company-details-form p-2">

                        <div className="row p-2">


                            <div className="col-12 col-md-6">
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="totalCarpetArea"
                                        name="totalCarpetArea"
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        value={totalCarpetArea}
                                        onChange={handleTotalCarpetArea}
                                        readOnly
                                        // readOnly={Number(noOfUnit) > 1}
                                        style={{ backgroundColor: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))
                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Total Carpet Area
                                    </label>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="input-box form-floating">
                                    <input
                                        type="tel"
                                        placeholder=""
                                        className=" form-control input-text form-control-sm mt-1"
                                        id="totalEmpCount"
                                        name="totalEmpCount"
                                        maxLength="10"
                                        pattern="[0-9]{10}"
                                        value={totalEmpCount}
                                        onChange={handleTotalEmpCount}
                                        // readOnly={Number(noOfUnit) > 1}
                                        readOnly
                                        style={{ backgroundColor: "transparent" }}
                                        onKeyDown={(e) => {
                                            const allowedKeys = [
                                                "Backspace",
                                                "Delete",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "Tab",
                                            ];
                                            const isDigit = /\d/.test(e.key);
                                            if (
                                                (isDigit || allowedKeys.includes(e.key))

                                            ) {
                                                return true;
                                            } else {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <label htmlFor="floatingInput" className="mt-2">
                                        Total Employee Count
                                    </label>
                                </div>
                            </div>


                            {/* {(proposalCounter !== "" && proposalCounter !== "0") && ( */}
                            <>







                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Select APs Count
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="accessPointCount"
                                            placeholder="Select Access Point"
                                            styles={style}
                                            value={accessPointCount}
                                            isSearchable={false}
                                            onChange={handleSelectAccessPointCount}
                                            options={optionAccessPointCount.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div>

                                {/* {console.log("accessPointCount",accessPointCount)} */}

                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Billing Frequency
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="PlanName"
                                            placeholder="Select Option"
                                            styles={style}
                                            value={billingFrequency}
                                            isSearchable={false}
                                            onChange={handleSelectBilling}
                                            options={optionTypeOption.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>
                                </div>


                                <div className="col-12 col-md-6">
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Select Plan Name
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="PlanName"
                                            placeholder="Select Option"
                                            styles={style}
                                            value={planName}
                                            isSearchable={false}
                                            onChange={handleSelectPlanName}
                                            // options={optionPlanName.map((data) => ({
                                            //     value: data.value,
                                            //     label: data.label,
                                            // }))}
                                            options={optionPlanName}
                                        // getOptionValue={(opt) => `${opt.plan_tier}|${opt.speedMbps}|${opt.dataTB}`}
                                        // getOptionLabel={(opt) => opt.label}
                                        />
                                    </div>
                                </div>


                                {console.log("otcPriceB", otcPriceB)}

                                <div className="col-12 col-md-6">
                                    <div className="mt-2">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            OTC Price
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Base Price"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePrice"
                                            name="basePrice"
                                            // value={userPriceData.basePrice}
                                            value={otcPriceB}
                                        // onChange={handleChange}
                                        />

                                    </div>
                                </div>

                                {(otcPriceB != "0" || "" || null) &&
                                    <div className="col-12 col-md-6">
                                        <div className="mt-2">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                Add OTC Discount
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="Enter Base price Discount"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="basePriceDis"
                                                name="basePriceDis"
                                                value={basePriceDis}
                                                onChange={handleBasePriceDis}
                                                disabled={oppStatus !== "Open"}
                                                style={{ background: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const input = e.target.value;
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>}


                                <div className="col-12 col-md-6">
                                    <div className="mt-2">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Number of Wired LAN Ports
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Number of Wired LAN Ports"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="noOfWiredLan"
                                            name="noOfWiredLan"
                                            value={noOfWiredLan}
                                            onChange={handleChangeNoOfWiredLan}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key)) &&
                                                    (noOfWiredLan?.length < 6 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div>
                                </div>

                                {Number(noOfWiredLan) > 0 && (
                                    <div className="col-12 col-md-6">
                                        <div>
                                            <label className="select-search-label mt-1">
                                                Wired LAN Devices
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                name="wiredLanDevices"
                                                placeholder="Select Wired LAN Devices"
                                                styles={style}
                                                value={wiredLanDevices}
                                                isSearchable={false}
                                                isMulti // ✅ make it multi select
                                                onChange={handleSelectWiredLanDevices}
                                                options={optionWiredLanDevices}
                                            />

                                        </div>
                                    </div>)}

                                {Number(noOfWiredLan) > 0 &&
                                    wiredLanDevices?.some((d) => d?.value === "OtherWiredLanDevice") && (
                                        <div className="col-12 col-md-6">
                                            <div className="mt-2">
                                                <label htmlFor="pgName1" className="pg-lable-style">
                                                    Specific Device Name
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Specific Device Name"
                                                    className="form-control input-text form-control-sm pg-input-style"
                                                    id="nameOfOtherWLD"
                                                    name="nameOfOtherWLD"
                                                    value={nameOfOtherWLD}
                                                    onChange={handleChangeNameOfOtherWLD}
                                                />
                                            </div>
                                        </div>)}

                                {Number(noOfWiredLan) > 0 && (
                                    <div className="col-12 col-md-6">
                                        <div className="mt-2">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                LAN Port Add-on Charges
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="LAN Port Add-on Charges"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="lanPortAddonCharges"
                                                name="lanPortAddonCharges"
                                                value={lanPortAddonCharges}
                                                onChange={handleChangeLanPortAddonCharges}
                                                readOnly
                                                style={{ backgroundColor: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key)) &&
                                                        (lanPortAddonCharges.length < 6 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                        </div>
                                    </div>)}

                                {(Number(noOfWiredLan) > 0 && billingFrequency.value != "B") && (
                                    <div className="col-12 col-md-6">
                                        <div className="mt-2">
                                            <label htmlFor="pgName1" className="pg-lable-style">
                                                LAN Port Add-on Charges Discount
                                            </label>
                                            <input
                                                type="text"
                                                placeholder="LAN Port Add-on Charges Discount"
                                                className="form-control input-text form-control-sm pg-input-style"
                                                id="lanPortAddonDiscount"
                                                name="lanPortAddonDiscount"
                                                value={lanPortAddonDiscount}
                                                onChange={handleChangeLanPortAddonDiscount}
                                                // style={{ backgroundColor: "transparent" }}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (isDigit || allowedKeys.includes(e.key)) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                            {lanPortAddonDiscount > 0 &&
                                                <div className='p-1'>
                                                    <span className="px-1 py-1 text-danger" >Proposal will be generated after DOA approval</span>
                                                </div>}
                                        </div>
                                    </div>)}

                                <div className="col-12 col-md-6">
                                    <div className="mt-">
                                        <label htmlFor="pgName1" className="pg-lable-style">
                                            Reason Of Discount
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Base price Discount"
                                            className="form-control input-text form-control-sm pg-input-style"
                                            id="basePriceReasonB"
                                            name="basePriceReasonB"
                                            value={userPriceData.basePriceReasonB}
                                            onChange={handleChange}
                                        />
                                    </div>

                                </div>
                            </>
                            {/* )} */}

                        </div>





                        <>
                            <div className="table-responsive mt-4">
                                <table className="table table-bordered custom-table">
                                    <thead>
                                        <tr className="table-dark">
                                            <th className="border border-black py-2">Parameter</th>
                                            <th className="border border-black py-2">Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(planDataShowAB) &&
                                            planDataShowAB.map((item, index) => (
                                                <React.Fragment key={index}>
                                                    {/* Plan Name */}
                                                    <tr>
                                                        <th>Plan Name</th>
                                                        <td>{item.plan_description}</td>
                                                    </tr>

                                                    {/* Office Specs */}
                                                    <tr>
                                                        <th rowSpan="2">Office Specifications</th>
                                                        <td className="p-0">
                                                            <table className="table m-0 table-bordered">
                                                                <thead>
                                                                    <tr className="office-spec-header">

                                                                        <th>Carpet Area</th>
                                                                        <th>Employee Count</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>

                                                                        <td>{totalCarpetArea} sq.ft.</td>
                                                                        <td>{totalEmpCount}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr></tr>

                                                    {/* Wi-Fi APs */}
                                                    <tr>
                                                        <th>Number of Wi-Fi Access Points</th>
                                                        <td>{accessPointCount ? accessPointCount?.value : ""} APs</td>
                                                    </tr>

                                                    {/* Plan Details */}
                                                    <tr>
                                                        <th>Speed</th>
                                                        <td>{item.broadband_speed}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Speed Post FUP</th>
                                                        <td>{item.speed_post_fup}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Data Volume</th>
                                                        <td>{item.data}</td>
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>

                                </table>
                            </div>


                            {/* Table for Charges */}
                            <div className="table-responsive mt-4">
                                <table className="table table-bordered custom-table">
                                    <thead>
                                        <tr className="table-dark">
                                            <th className="border border-black py-2">Charge Type</th>
                                            <th className="border border-black py-2">Charges</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>One Time Charges (OTC)</th>
                                            <td>
                                                {discountedBasePrice
                                                    ? discountedBasePrice
                                                    : planDataShowAB?.[0]?.otc}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Monthly Recurring Charges</th>
                                            <td>
                                                {planDataShowAB?.[0]?.monthly_price}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>LAN Port Add-on Charges</th>
                                            <td>
                                                {extendedLanCharges ? extendedLanCharges : lanPortAddonCharges}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </>

                        <div className=" text-center p-5">
                            <button
                                type="button"
                                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                onClick={handleCreateProposal}
                            >
                                Generate Proposal
                            </button>
                        </div>
                    </fieldset>
                </div>
            )}
        </>
    )
}

export default SelectProductSOHO